import { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight, Phone } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { COMPANY, NAV_LINKS } from "../lib/constants";
import { useScrollTo } from "../hooks/useScrollTo";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const scrollTo = useScrollTo();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    const onResize = () => { if (window.innerWidth >= 1024) setOpen(false); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('keydown', onKey);
    window.addEventListener('resize', onResize);
    return () => { window.removeEventListener('scroll', onScroll); window.removeEventListener('keydown', onKey); window.removeEventListener('resize', onResize); };
  }, []);
  const go = (id) => { setOpen(false); scrollTo(id); };
  return (
    <header data-testid="site-navbar" className={`solar-nav ${scrolled ? 'is-scrolled' : ''}`}>
      <div className="site-container nav-layout">
        <button onClick={() => go('hero')} className="nav-brand" data-testid="nav-logo" aria-label="Tech Thrissur — home">
          <img src={scrolled ? COMPANY.logo : COMPANY.logoDark} alt="TECH THRISSUR — Own The Best!" width="588" height="642" data-testid="nav-logo-image" />
          <span className="nav-brand-caption eyebrow">SOLAR ENERGY<br />THRISSUR, KERALA</span>
        </button>
        <nav className="desktop-nav hidden lg:flex" aria-label="Main navigation">
          {NAV_LINKS.map((l) => <button key={l.id} onClick={() => go(l.id)} data-testid={`nav-link-${l.id}`} className="nav-link">{l.label}</button>)}
        </nav>
        <div className="flex items-center gap-4">
          <motion.a href={`tel:${COMPANY.phones[0].replace(/\s/g, '')}`} data-testid="nav-call-btn" className="nav-call hidden md:inline-flex" whileHover={{ y: -2 }} whileTap={{ scale: 0.97 }}>Let’s Talk Solar <ArrowUpRight size={17} /></motion.a>
          <button className="nav-toggle lg:hidden" onClick={() => setOpen(!open)} data-testid="nav-menu-toggle" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} aria-controls="mobile-navigation">{open ? <X size={25} /> : <Menu size={25} />}</button>
        </div>
      </div>
      <AnimatePresence>
        {open && <motion.nav id="mobile-navigation" aria-label="Mobile navigation" initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} transition={{ duration: 0.25 }} className="mobile-navigation lg:hidden" data-testid="mobile-menu">
          {NAV_LINKS.map((l, i) => <button key={l.id} onClick={() => go(l.id)} data-testid={`mobile-link-${l.id}`}><span className="eyebrow">0{i + 1}</span>{l.label}<ArrowUpRight size={18} /></button>)}
          <a href={`tel:${COMPANY.phones[0].replace(/\s/g, '')}`} data-testid="mobile-call-btn" className="solar-button"><Phone size={16} /> Call Now</a>
        </motion.nav>}
      </AnimatePresence>
    </header>
  );
};
